import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Paper,
  Button,
  Divider,
  Avatar,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
} from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "../../styles/Booking.scss";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import GroupIcon from "@mui/icons-material/Group";
import ReceiptIcon from "@mui/icons-material/Receipt";
import CancelIcon from "@mui/icons-material/Cancel";
import { BOOKINGS } from "../../component/common/Routes/AppRoutes";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { VENDOR_BOOKINGS } from "../../component/common/Routes/VendorRoutes";
import { CUSTOMER_BOOKINGS } from "../../component/common/Routes/CustomerRoutes";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchBookingRequest,
  resetBookingDetails,
  updateBookingDiscountApprovalStatusRequest,
} from "../../redux/Bookings/BookingAction";
import Loading from "../../component/ui/Loading";
import CustomButton from "../../component/ui/FormFields/Button";
import { toast, ToastContainer } from "react-toastify";
import { formatDateWithAmPm } from "../../Style";
import PassengerTable from "./PassengerTable";
import AirportDetailsTable from "../UnAuthBooking/AirportDetailsTable";

const BookingInvoice = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const tab = location.state.tab ?? 0;
  const page = location.state.page ?? 1;
  const pageSize = location.state.pageSize ?? 10;

  const complementaryStatus = location.state?.complementaryStatus ?? 2;
  const instantStatus = location.state?.instantStatus ?? 2;
  const searchQuery = location.state?.searchQuery ?? "";

  const { bookingId } = useParams();
  useEffect(() => {
    dispatch(fetchBookingRequest(bookingId));
    dispatch(resetBookingDetails());
  }, []);
  const user = useSelector((state) => state.auth.user);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const bookingDetails = useSelector(
    (state) => state.booking?.booking?.data[0],
  );
  const isPorter = bookingDetails?.Service?.services
    ?.toLowerCase()
    .includes("porter");

  // const number_of_adults = bookingDetails?.BookingDetail?.number_of_adults;
  // const number_of_child = bookingDetails?.BookingDetail?.number_of_child;

  const number_of_service = bookingDetails?.BookingDetail?.number_of_service;

  const consoldateBookingDetails = useSelector(
    (state) => state.booking?.booking,
  );

  const totalDiscount = consoldateBookingDetails?.totalDiscount;
  const promoDiscount = consoldateBookingDetails?.totalPromoCodeDiscount;

  const approvalMessage = useSelector(
    (state) => state.booking?.approval_message,
  );
  const loadings = useSelector((state) => state.booking?.loading);
  const [initialStatus, setInitialStatus] = useState("");
  const bookingDetail = useSelector((state) => state.booking);

  const [approvalStatus, setApprovalStatus] = useState(
    bookingDetails?.approoved_status || null,
  );

  const adultFamilyMember = bookingDetails?.bookingFamilies?.filter((adult) => {
    return adult?.familyMember?.age >= 12;
  });

  const childFamilyMember = bookingDetails?.bookingFamilies?.filter((child) => {
    return child?.familyMember?.age >= 2 && child?.familyMember?.age < 12;
  });
  const adultDiscount = adultFamilyMember?.[0]?.familyMember?.discount || 0;
  const childDiscount = childFamilyMember?.[0]?.familyMember?.discount || 0;

  useEffect(() => {
    if (approvalMessage) {
      toast.success("Complementry Status Changed", {
        position: "top-center",
        autoClose: 3000,
        onClose: () => {
          dispatch(resetBookingDetails());
          navigate(-1);
        },
      });
    }
  }, [approvalMessage]);
  useEffect(() => {
    if (bookingDetails) {
      setApprovalStatus(bookingDetails.approove_status);
      setInitialStatus(bookingDetails.approove_status);
    }
  }, [bookingDetails]);

  const handleApprovalStatusChange = (event) => {
    setApprovalStatus(parseInt(event.target.value));
  };
  const handleApprovalStatusSubmit = async () => {
    setIsSubmitting(true);

    const payload = {
      booking_id: bookingDetails.id,
      approval_status: approvalStatus,
    };

    try {
      await dispatch(updateBookingDiscountApprovalStatusRequest(payload));
      await dispatch(fetchBookingRequest(bookingId));
    } catch (error) {
      alert("Failed to update approval status. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const service =
    bookingDetails?.service_type === 1
      ? "Arrival"
      : bookingDetails?.service_type === 2
        ? "Departure"
        : "Transit";

  const loading = bookingDetail?.loading;
  if (loading) {
    return <Loading text="Loading Booking details..." />;
  }

  const showPendingOption = initialStatus === "2" || initialStatus === 2;

  const bookingData = [
    {
      icon: <GroupIcon className="passenger-icon" />,
      title: "Passenger Details",
      fields: [
        {
          label: "No. of Adults",
          value: bookingDetails?.BookingDetail?.number_of_adults || "0",
        },
        {
          label: "No. of Children",
          value: bookingDetails?.BookingDetail?.number_of_child || "0",
        },
        {
          label: "No. of Infants",
          value: bookingDetails?.BookingDetail?.number_of_infant || "0",
        },
        {
          label: "Total Passengers",
          value: bookingDetails?.BookingDetail?.total_passengers || "0",
        },
      ],
    },
    {
      icon: <FlightTakeoffIcon className="service-icon" />,
      title: "Service Details",
      fields: [
        {
          label: "Service",
          value: bookingDetails?.Service?.services || "-",
        },
        {
          label: "Arrival/Departure",
          value: service || "-",
        },
        {
          label: "Service Type",
          value: bookingDetails?.airport_type || "-",
        },
        {
          label: "Number of Services",
          value: number_of_service || "-",
        },
      ],
    },
  ];

  const currencyFormatter = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 2,
  });

  const isVendor =
    bookingDetails?.BookingDetail?.booked_user_type === 2 &&
    (user?.role === "Admin" ||
      user?.role === "Staff" ||
      user?.role === "Vendor");
  const orderSource = isVendor
    ? bookingDetails?.vendorBookLogs?.[0]
    : bookingDetails?.Order;
  const sgstPercentage = (
    (orderSource?.sgst / orderSource?.sub_total) * 100 || 0
  ).toFixed(0);
  const cgstPercentage = (
    (orderSource?.cgst / orderSource?.sub_total) * 100 || 0
  ).toFixed(0);
  const taxPercentage = (
    (bookingDetails?.Order?.tax / orderSource?.sub_total) * 100 || 0
  ).toFixed(0);
  const GrossAmount = parseFloat(
    number_of_service * bookingDetails?.Order?.price,
  );

  const AdultPrice = -parseFloat(consoldateBookingDetails?.totalAdultDiscount);
  const ChildPrice = -parseFloat(consoldateBookingDetails?.totalChildDiscount);

  const emergency_contact = bookingDetails?.BillingAddress?.emergency_contact;
  const orderSummary = {
    totals: [
      {
        label: "Gross Amount",
        value: 0,
        formattedValue: currencyFormatter.format(GrossAmount || 0),
      },
      adultFamilyMember?.length > 0 && {
        label: `Adult Discount(${adultDiscount}%)`,
        value: 0,
        formattedValue: currencyFormatter.format(AdultPrice || 0),
      },
      childFamilyMember?.length > 0 &&
        !isPorter && {
          label: `Child Discount(${childDiscount}%)`,
          value: 0,
          formattedValue: currencyFormatter?.format(ChildPrice || 0),
        },

      orderSource &&
        bookingDetails?.BookingDetail?.booked_user_type === 2 &&
        (user?.role === "Admin" ||
          user?.role === "Staff" ||
          user?.role === "Vendor") && {
          label: `Vendor Commission (${orderSource?.vendor_commision_rate}%)`,
          value: orderSource?.vendor_commision || 0,
          formattedValue: currencyFormatter.format(
            -orderSource?.vendor_commision || 0,
          ),
        },
      orderSource?.discount >= 0 && {
        label: `Booking Discount (${
          orderSource?.discount ? orderSource?.discount : 0
        }%)`,
        value: -parseFloat(totalDiscount) || 0,
        formattedValue: currencyFormatter.format(
          -parseFloat(totalDiscount) || 0,
        ),
      },
      promoDiscount > 0 && {
        label: `Promo Code Discount (${
          bookingDetails?.Promocode?.discount_percent
            ? bookingDetails?.Promocode?.discount_percent
            : 0
        }%)`,
        value: -parseFloat(promoDiscount) || 0,
        formattedValue: currencyFormatter.format(
          -parseFloat(promoDiscount) || 0,
        ),
      },
      orderSource?.sub_total >= 0 && {
        label: "SubTotal",
        value: parseFloat(orderSource.sub_total) || 0,
        formattedValue: currencyFormatter.format(
          parseFloat(orderSource.sub_total) || 0,
        ),
      },

      orderSource?.additional_payment > 0 && {
        label: `Instant Booking Charge`,
        value: parseFloat(orderSource?.additional_payment) || 0,
        formattedValue: currencyFormatter.format(
          parseFloat(orderSource?.additional_payment) || 0,
        ),
      },
      bookingDetails?.totalPenaltyCharge > 0 && {
        label: `Edit Booking Charge`,
        value: 0,
        formattedValue: currencyFormatter.format(
          parseFloat(bookingDetails?.totalPenaltyCharge) || 0,
        ),
      },
      bookingDetails?.Order?.tax >= 0 && {
        label: `IGST (${taxPercentage ? taxPercentage : 0}%)`,
        value: parseFloat(bookingDetails?.Order?.tax) || 0,
        formattedValue: currencyFormatter.format(
          parseFloat(bookingDetails?.Order?.tax) || 0,
        ),
      },

      orderSource?.sgst >= 0 && {
        label: `SGST (${sgstPercentage}% )`,
        value: parseFloat(orderSource.sgst) || 0,
        formattedValue: currencyFormatter.format(
          parseFloat(orderSource.sgst) || 0,
        ),
      },
      orderSource?.cgst >= 0 && {
        label: `CGST (${cgstPercentage}%)`,
        value: parseFloat(orderSource.cgst) || 0,
        formattedValue: currencyFormatter.format(
          parseFloat(orderSource.cgst) || 0,
        ),
      },
    ].filter(Boolean),
  };

  const totalAmount = orderSummary.totals.reduce(
    (sum, item) => sum + item.value,
    0,
  );

  // Create form1Value and form2Value objects based on bookingDetails for compatibility with tables
  const form1Value = {
    airport: { label: bookingDetails?.airport_name || "-" },
    type_of_class: {
      label: bookingDetails?.BookingDetail?.type_of_class || "-",
    },
    arrival_date: bookingDetails?.BookingDetail?.date_of_arrival,
    arrival_time: bookingDetails?.BookingDetail?.time_of_arrival,
    arrival_flight_number: bookingDetails?.BookingDetail?.arrival_flight_number,
    arival_pnr_by_customer: bookingDetails?.arival_pnr_by_customer,
    arrival_airline: bookingDetails?.BookingDetail?.arrival_airlines,
    departure_date: bookingDetails?.BookingDetail?.date_of_departure,
    departure_time: bookingDetails?.BookingDetail?.time_of_departure,
    departure_flight_number:
      bookingDetails?.BookingDetail?.departure_flight_number,
    departure_pnr_by_customer: bookingDetails?.departure_pnr_by_customer,
    departure_airline: bookingDetails?.BookingDetail?.departure_airlines,
    arrival_departure_type: { value: service },
  };

  const form2Value = {
    family_members:
      bookingDetails?.bookingFamilies?.map((member) => ({
        ...member?.familyMember,
        id: member?.familyMember?.id,
      })) || [],
  };

  const renderFields = (fields) =>
    fields.map((item, index) => (
      <Box key={index} className="label-value-container">
        <Typography variant="body1" className="label-style">
          {item.label}
        </Typography>
        <Typography variant="body1" className="value-style">
          {item.value}
        </Typography>
      </Box>
    ));

  const hasCancellationNotes = bookingDetails?.BookingDetail?.cancel_notes;

  return (
    <>
      <ToastContainer />
      <Box className="booking-summary-body">
        <Typography variant="h6" className="form-heading" gutterBottom mb={3}>
          View Booking - {bookingDetails?.pnr_number}
        </Typography>
        <Grid container spacing={4}>
          {/* Passenger Details (First Box) */}
          {bookingData[0] && (
            <Grid
              item
              xs={12} // Full width on small screens
              md={6} // Half-width on medium screens
              xl={6} // One-third width on 1440px and above
              key="row1-box1"
            >
              <Paper elevation={4} className="booking-summary-paper">
                <Box className="booking-summary-content-box">
                  <Box className="booking-heading-alignment">
                    <Avatar className="booking-summary-avatar-style">
                      {bookingData[0].icon}
                    </Avatar>
                    <Typography
                      variant="h6"
                      className="booking-summary-title-style"
                    >
                      {bookingData[0].title}
                    </Typography>
                  </Box>
                  <Divider
                    sx={{
                      margin: "10px 0",
                      borderColor: "#ddd",
                      width: "100%",
                    }}
                  />
                </Box>
                {renderFields(bookingData[0].fields)}
              </Paper>
            </Grid>
          )}

          {/* Service Details (Second Box) */}
          {bookingData[1] && (
            <Grid
              item
              xs={12} // Full width on small screens
              md={6} // Half-width on medium screens
              xl={6} // One-third width on 1440px and above
              key="row1-box2"
            >
              <Paper elevation={4} className="booking-summary-paper">
                <Box className="booking-summary-content-box">
                  <Box className="booking-heading-alignment">
                    <Avatar className="booking-summary-avatar-style">
                      {bookingData[1].icon}
                    </Avatar>
                    <Typography
                      variant="h6"
                      className="booking-summary-title-style"
                    >
                      {bookingData[1].title}
                    </Typography>
                  </Box>
                  <Divider
                    sx={{
                      margin: "10px 0",
                      borderColor: "#ddd",
                      width: "100%",
                    }}
                  />
                </Box>
                {renderFields(bookingData[1].fields)}
              </Paper>
            </Grid>
          )}

          {/* Passenger Information Table */}
          <Grid item xs={12}>
            <PassengerTable form2Value={form2Value} />
          </Grid>

          {/* Airport Details Table */}
          <Grid item xs={12} md={6} xl={6} key="airport-details">
            <AirportDetailsTable form1Value={form1Value} />
          </Grid>

          {/* Order Summary */}
          <Grid item xs={12} md={6}>
            <Paper elevation={4} className="unauth-booking-summary-order-paper">
              <Box className="booking-summary-order-box">
                <Avatar className="booking-summary-order-avatar">
                  <ReceiptIcon className="booking-summary-receipticon" />
                </Avatar>
                <Typography
                  variant="h6"
                  className="booking-summary-title-style"
                >
                  Order Summary
                </Typography>
              </Box>
              <Divider className="booking-summary-divider" />

              {orderSummary.totals.map((item, index) => (
                <Box key={index} className="booking-summary-order-content">
                  <Typography
                    variant="body1"
                    className="booking-summary-total-label"
                  >
                    {item.label}
                  </Typography>
                  <Typography
                    variant="body1"
                    className="booking-summary-total-value"
                  >
                    {item.formattedValue}
                  </Typography>
                </Box>
              ))}
              <Divider className="booking-summary-divider" />
              <Box
                className="booking-summary-order-content"
                sx={{ paddingBottom: "20px" }}
              >
                <Typography
                  variant="h6"
                  className="booking-summary-total-label"
                >
                  Total
                </Typography>
                <Typography
                  variant="h6"
                  className="booking-summary-total-value"
                >
                  {currencyFormatter.format(
                    isVendor
                      ? bookingDetails?.totalVendorBookingCharge
                      : bookingDetails?.totalBookingCharge,
                  )}
                </Typography>
              </Box>
            </Paper>
          </Grid>

          {bookingDetails?.BookingDetail?.vendor_gst_number && (
            <Grid item xs={12} md={6} display="flex" alignItems="center">
              <Typography
                variant="h6"
                className="booking-summary-title-style"
                sx={{ mr: 2 }}
              >
                Vendor GST Number :
              </Typography>
              <Typography variant="body1" className="vendor-gst-text">
                {bookingDetails.BookingDetail.vendor_gst_number}
              </Typography>
            </Grid>
          )}

          {user?.role === "Admin" && bookingDetails?.booked_type === 2 && (
            <Grid item xs={12}>
              <Typography variant="subtitle1" gutterBottom>
                Approval Status
              </Typography>
              <Grid container spacing={2} direction="row" alignItems="center">
                <Grid item>
                  <RadioGroup
                    value={approvalStatus}
                    onChange={handleApprovalStatusChange}
                    row
                  >
                    <FormControlLabel
                      value={1}
                      control={<Radio color="success" />}
                      label="Approved"
                    />
                    {showPendingOption && (
                      <FormControlLabel
                        value={2}
                        control={<Radio color="warning" />}
                        label="Pending"
                        disabled={isSubmitting}
                      />
                    )}
                    <FormControlLabel
                      value={3}
                      control={<Radio color="error" />}
                      label="Rejected"
                    />
                  </RadioGroup>
                </Grid>
                <Grid item>
                  <CustomButton
                    variant="contained"
                    className="success-button"
                    text="Submit Approval Status"
                    loading={loadings}
                    onClick={handleApprovalStatusSubmit}
                  />
                </Grid>
              </Grid>
            </Grid>
          )}

          {/* Cancellation Notes Box */}
          {hasCancellationNotes && (
            <Grid item xs={12}>
              <Paper elevation={2} className="booking-cancellation-paper">
                <Box className="booking-cancellation-box">
                  <Box className="booking-cancellation-header">
                    <Avatar className="booking-cancellation-avatar">
                      <CancelIcon className="cancellation-icon" />
                    </Avatar>
                    <Typography
                      variant="h6"
                      className="booking-cancellation-title"
                    >
                      Booking Cancelled
                    </Typography>
                  </Box>
                  <Divider className="booking-cancellation-divider" />
                  <Typography
                    variant="subtitle1"
                    className="booking-cancellation-subtitle"
                  >
                    Cancellation Reason:
                  </Typography>
                  <Box className="cancellation-notes-container">
                    <Typography
                      variant="body1"
                      className="booking-cancellation-notes"
                    >
                      {bookingDetails?.BookingDetail?.cancel_notes}
                    </Typography>
                  </Box>
                </Box>
              </Paper>
            </Grid>
          )}

          {/* Back Button */}
          <Grid
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              variant="contained"
              className="grey-button"
              onClick={() => {
                let bookingsRoute;

                if (user.role === "Admin" || user.role === "Staff") {
                  bookingsRoute = BOOKINGS;
                } else if (user.role === "Vendor") {
                  bookingsRoute = VENDOR_BOOKINGS;
                } else if (user.role === "Customer") {
                  bookingsRoute = CUSTOMER_BOOKINGS;
                }

                navigate(bookingsRoute, {
                  state: {
                    tab: tab,
                    page: page,
                    pageSize: pageSize,
                    complementaryStatus: complementaryStatus,
                    instantStatus: instantStatus,
                    searchQuery: searchQuery,
                  },
                });
              }}
            >
              Back
            </Button>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
export default BookingInvoice;
